import { Button } from '@mui/material';
import React from 'react';
import { NavLink } from 'react-router-dom';

const EventsList = () => {
    return (
        <div>
            it's me
            <Button variant="contained"><NavLink to="update/dsfsdfsdf">update</NavLink></Button>
        </div>
    );
};

export default EventsList;